import axios from 'axios'
import settings from '../../settings'

const users = {
    namespaced: true,
    state: () => ({
        all:[]
      }),
      mutations:{
         updateUsersState(state,data){
             state.all=data;
         }
      },
      actions: {
        fetchUsers({commit}){
            axios.get(`${settings.apiUrl}/users`).then(res => {
					commit('updateUsersState',res.data)
			 });
        },
      },
      getters: {
           
      }
}

export default users;

 